import * as React from 'react';

import { useState, useEffect, Fragment } from 'react';
import StepOneForm from './StepOneForm';
import StepTwoStatus from './StepTwoStatus';
import { supabase } from '../../../../api';

import { Paper } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { PROFILE_TABLE } from '../../../../constants/supabase_constants';

const steps = ['Application Form', 'Outcome Status'];

export default function HorizontalLinearStepper({ session, membershipLevel }) {
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  const getProfile = async () => {
    try {
      setLoading(true);
      const user = supabase.auth.user();

      let { data, error, status } = await supabase
        .from(PROFILE_TABLE)
        .select(`membershipLevel`)
        .eq('id', user.id)
        .single();

      if (error && status !== 406) {
        throw error;
      }

      if (data) {
        if (data.membershipLevel === 'member') {
          setActiveStep(2);
        } else if (data.membershipLevel === 'applied') {
          setActiveStep(1);
        } else {
          setActiveStep(0);
        }
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const content = () => {
    switch (activeStep) {
      case 0:
        return <StepOneForm activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />;
      default:
        return <StepTwoStatus activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} steps={steps} />;
    }
  };

  return (
    <Fragment>
      {loading ? (
        'Loading ...'
      ) : (
        <Paper
          elevation={20}
          sx={{
            mt: '2rem',
            textAlign: 'left',
            width: '100%',
            position: 'relative',
          }}>
          <Paper
            sx={{
              padding: '2rem',
            }}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            {content()}
          </Paper>
        </Paper>
      )}
    </Fragment>
  );
}
